export default [
    {
        path: '/profile',
        redirect: '/home',
        name: 'profile',
        component: () => import('@/views/Profile.vue'),
        meta: {
            requiresAuth: true,
            layout: 'contact'
        }
    },

]
